/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
// export const baseUrl = 'http://192.168.43.58:8081'

export const baseUrl = process.env.HOST
export const uploadUrl = process.env.UPLOAD
// 后台管理登录
export const loginUrl = '/login'
// 后台管理首页
export const homeUrl = '/home'
// 后台管理首页
export const notFound = '/404'

// labelType 类型
export const labelTypeMap = {
    'APP及H5': 1,
    'WEB端': 1,
    '轻松艺考（微信小程序）': 1,
    '合作方（微信小程序）': 2,
    '抖音小程序': 2,
    '百度小程序': 2,
    '自然流量（微信小程序）': 2
}

// 返回uuid全局唯一变量
export function uuid() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'

    var uuid = s.join('')
    return uuid
}
export function generateKey() {
    const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
    let nums = ''
    for (let i = 0; i < 16; i++) {
        const id = parseInt(Math.random() * 61)
        nums += chars[id]
    }
    return nums
}

export default {
    baseUrl,
    loginUrl,
    homeUrl,
    notFound,
    uploadUrl,
    uuid,
    generateKey
}



// WEBPACK FOOTER //
// ./src/utils/global.js